import React, { useEffect } from 'react';
import { createNativeStackNavigator } from '@react-navigation/native-stack';
import { routes, type KioskStackParamList } from '../constants/routes';
import { ForgotPasswordScreen } from '../screens/auth/ForgotPasswordScreen';
import { LoginScreen } from '../screens/auth/LoginScreen';
import { KioskAttendanceScreen } from '../screens/kiosk/KioskAttendanceScreen';
import {
  registerKioskSessionInvalidationHandler,
  restoreKioskSession,
} from '../services/kioskAuthService';

const Stack = createNativeStackNavigator<KioskStackParamList>();

/**
 * Kiosk landing is always Mark Attendance (+ Login).
 * Activation runs only when Mark Attendance is tapped and the device is not ACTIVE.
 */
export function KioskNavigator() {
  useEffect(() => {
    restoreKioskSession().catch(() => undefined);
    registerKioskSessionInvalidationHandler(() => {
      // Tokens cleared; next Mark Attendance will prompt activation.
    });
    return () => registerKioskSessionInvalidationHandler(null);
  }, []);

  return (
    <Stack.Navigator screenOptions={{ headerShown: false }}>
      <Stack.Screen name={routes.kiosk} component={KioskAttendanceScreen} />
      <Stack.Screen name={routes.login} component={LoginScreen} />
      <Stack.Screen
        name={routes.forgotPassword}
        component={ForgotPasswordScreen}
      />
    </Stack.Navigator>
  );
}
